import { useTranslation } from "react-i18next";
import { DestinationLogo } from "../SelectDestination/destinations/DestinationLogo";
import styles from "./index.module.scss";
import { FacebookProfile } from "store/platforms/types";
import { DestinationDescriptor } from "views/page-content/platforms/platform/simulcast/types";

export const DestinationHeader = ({
    specificDestination,
    profileInfo
}: {
    specificDestination: DestinationDescriptor | null;
    profileInfo?: FacebookProfile;
}) => {
    const { t } = useTranslation();
    return (
        <>
            <div className={styles["destination-header"]}>
                <DestinationLogo destination={specificDestination} />
                <span>
                    <p className={styles["stream-to"]}>
                        {t("platforms:stream-to")}
                    </p>
                    <p className={styles["destination-name"]}>
                        {specificDestination?.name}
                        {profileInfo?.name ? ` - ${profileInfo?.name}` : null}
                    </p>
                </span>
            </div>
            <hr />
        </>
    );
};
